import { generalHelpers, dropHelpers } from '@/_helpers'
import i18n from '@/i18n.js'
const getters = {
  getDropDetails: (state) => {
    if (state.selectedDropDetailsView !== null) {
      return state.selectedDropDetailsView
    }
    return null
  },
  getSelectedDrop: (state) => {
    if (state.selectedDropDetails !== null) {
      if (state.selectedDropDetails.units !== null) {
        return state.selectedDropDetails
      } else {
        return { ...state.selectedDropDetails, units: false }
      }
    }
    return {}
  },
  getDropUnits: (state) => {
    return state.dropUnits
  },
  getDropTree: (state) => (dropID, applyFilters = true) => {
    let tree = []
    const units = JSON.parse(JSON.stringify(state.dropUnitsHash))
    if (state.dropUnitsHashKeys[dropID] !== undefined) {
      let keys = [...state.dropUnitsHashKeys[dropID]]
      let index = 0
      while (keys.length > index) {
        if (state.dropUnitsHashKeys[keys[index]] !== undefined) {
          keys = generalHelpers.mergeArrays(keys, state.dropUnitsHashKeys[keys[index]], (index + 1))
        }
        ++index
      }
      keys.forEach((key) => {
        if (units[key] !== undefined) {
          if (units[key].parent === dropID) {
            tree.push(units[key])
          } else {
            if (units[units[key].parent] !== undefined) {
              units[units[key].parent].children.push(units[key])
            }
          }
        }
      })
    }
    if (applyFilters) {
      if (state.filteredByOrderRef.length > 0) {
        tree = tree.filter((object) => {
          if (object.items !== null && object.items.length > 0) {
            return state.filteredByOrderRef.indexOf(object.items[0].orderRef) >= 0
          } else {
            return true
          }
        })
      }
      if (state.filteredByCustomerRef.length > 0) {
        tree = tree.filter((object) => {
          if (object.items !== null && object.items.length > 0) {
            return state.filteredByCustomerRef.indexOf(object.transport.order.buyer.ref) >= 0
          } else {
            return true
          }
        })
      }
      if (state.filteredByItemCategory.length > 0) {
        tree = tree.filter((object) => {
          if (object.items !== null && object.items.length > 0) {
            let hasItemWithCategory = false
            state.filteredByItemCategory.forEach((filterCategory) => {
              const index = object.items.findIndex(({ category }) => {
                return filterCategory === category
              })
              if (index >= 0) {
                hasItemWithCategory = true
              }
            })
            return hasItemWithCategory
          } else {
            return true
          }
        })
      }
      if (state.sortedBy !== null) {
        if (state.sortedBy === 'weight') {
          tree.forEach((object) => {
            object['calculatedWeight'] = dropHelpers.calculateUnitWeight(object)
          })
          tree.sort(generalHelpers.compareObjectProperty('calculatedWeight'))
          return tree.sort(generalHelpers.compareObjectPropertyLength('children'))
        } else if (state.sortedBy === 'largest_dimension') {
          tree.forEach((object) => {
            object['largestDimension'] = Math.max(object.dimensions.length, object.dimensions.width, object.dimensions.height)
          })
          tree.sort(generalHelpers.compareObjectProperty('largestDimension'))
          return tree.sort(generalHelpers.compareObjectPropertyLength('children'))
        }
      }
    }
    return tree.sort(generalHelpers.compareObjectPropertyLength('children'))
  },
  getFilteredDropUnitsHash: (state) => (dropID) => {
    let units = JSON.parse(JSON.stringify(state.dropUnitsHash))
    units = Object.keys(units).map((key) => units[key])
    if (state.filteredByOrderRef.length > 0) {
      units = units.filter((object) => {
        if (object.items !== null && object.items.length > 0) {
          return state.filteredByOrderRef.indexOf(object.items[0].orderRef) >= 0
        } else {
          return true
        }
      })
    }
    if (state.filteredByCustomerRef.length > 0) {
      units = units.filter((object) => {
        if (object.items !== null && object.items.length > 0) {
          return state.filteredByCustomerRef.indexOf(object.transport.order.buyer.ref) >= 0
        } else {
          return true
        }
      })
    }
    const unitsObject = {}
    units.forEach((unit) => {
      unitsObject[unit.id] = unit
    })
    return unitsObject
  },
  getToggleUnitIndex: (state) => (unitID) => {
    return state.checkedUnits.indexOf(unitID)
  },
  getToggleAllState: (state) => (numberOfUnits) => {
    if (numberOfUnits === state.checkedUnits.length && state.checkedUnits.length !== 0 && numberOfUnits !== 0) {
      return 'all'
    } else if (state.checkedUnits.length === 0) {
      return 'none'
    } else {
      return 'indeterminate'
    }
  },
  getSelectedUnit: (state) => {
    return state.selectedUnit
  },
  getToggledUnits: (state) => {
    return state.checkedUnits.map((unitID) => state.dropUnitsHash[unitID])
  },
  getIsMergeable: (state) => (dropID) => {
    let flag = true
    state.checkedUnits.forEach((key) => {
      if (state.dropUnitsHash[key].parent !== dropID) {
        flag = false
      }
    })
    return flag
  },
  getUnitsChildren: (state) => (unitID) => {
    let count = 0
    state.dropUnits.forEach((unit) => {
      if (unit.parent === unitID) {
        count += 1
      }
    })
    return count
  },
  getDropAllUnits: (state) => {
    return state.dropUnitsHash
  },
  getActiveFilters: (state) => {
    return [].concat(state.filteredByOrderRef, state.filteredByCustomerRef, state.filteredByItemCategory)
  },
  getActiveFilteredByOrderRef: (state) => {
    return [].concat(state.filteredByOrderRef)
  },
  getIsLoading: (state) => {
    return state.isLoading
  },
  getDropOrders: (state) => {
    let labelsArray = []
    let arrayRef = []
    let newOrderRefUnits = []
    let newCustomerRefUnits = []
    let newItemsCategoryUnits = []
    let allUnits = JSON.parse(JSON.stringify(state.dropUnitsHash))
    if (state.filteredByOrderRef.length > 0) {
      newOrderRefUnits = Object.keys(allUnits).filter((key) => {
        if (allUnits[key].transport.order != null) {
          return state.filteredByOrderRef.indexOf(allUnits[key].transport.order) >= 0
        } else {
          return true
        }
      })
    }
    if (state.filteredByCustomerRef.length > 0) {
      newCustomerRefUnits = Object.keys(allUnits).filter((key) => {
        if (allUnits[key].items !== null && allUnits[key].transport.order != null) {
          return state.filteredByCustomerRef.indexOf(allUnits[key].transport.order.buyer.ref) >= 0
        } else {
          return true
        }
      })
    }
    if (state.filteredByItemCategory.length > 0) {
      newItemsCategoryUnits = Object.keys(allUnits).filter((key) => {
        if (allUnits[key].items !== null && allUnits[key].transport.order != null) {
          let hasItemWithCategory = false
          state.filteredByItemCategory.forEach((filterCategory) => {
            const index = allUnits[key].items.findIndex(({ category }) => {
              return filterCategory === category
            })
            if (index >= 0) {
              hasItemWithCategory = true
            }
          })
          return hasItemWithCategory
        } else {
          return true
        }
      })
    }
    if (newOrderRefUnits.length > 0) {
      Object.keys(allUnits).forEach((key) => {
        if (newOrderRefUnits.indexOf(key) < 0) {
          delete allUnits[key]
        }
      })
    }
    if (newCustomerRefUnits.length > 0) {
      Object.keys(allUnits).forEach((key) => {
        if (newCustomerRefUnits.indexOf(key) < 0) {
          delete allUnits[key]
        }
      })
    }
    if (newItemsCategoryUnits.length > 0) {
      Object.keys(allUnits).forEach((key) => {
        if (newItemsCategoryUnits.indexOf(key) < 0) {
          delete allUnits[key]
        }
      })
    }
    Object.keys(allUnits).forEach((key) => {
      if (allUnits[key].type === 'CustomBox') { // TODO maybe changed
        if (allUnits[key].transport.order != null) {
          const index = arrayRef.indexOf(allUnits[key].transport.ref)
          if (index < 0) {
            labelsArray.push({
              name: allUnits[key].transport.ref,
              buyerRef: allUnits[key].transport.order.buyer.ref,
              subtitle: 1,
              id: allUnits[key].transport.ref,
              toggled: state.toggledOrders.indexOf(allUnits[key].transport.ref) >= 0
            })
            arrayRef = labelsArray.map(({ name }) => name)
          } else {
            labelsArray[index].subtitle += 1
          }
        }
      }
    })
    labelsArray.forEach((order) => {
      order.subtitle = `${i18n.t('packages_type.boxes')}: ${order.subtitle}`
    })
    return labelsArray
  },
  getDropsCustomerRefs: (state) => {
    let customerRefs = [].concat(state.filteredByCustomerRef)
    let allUnits = state.dropUnitsHash
    Object.keys(allUnits).forEach((key) => {
      if (allUnits[key].transport != null) {
        if (allUnits[key].transport.order != null) {
          if (allUnits[key].transport.order.buyer.ref != null) {
            if (customerRefs.indexOf(allUnits[key].transport.order.buyer.ref) < 0) {
              customerRefs.push(allUnits[key].transport.order.buyer.ref)
            }
          }
        }
      }
    })
    return customerRefs
  },
  getDropsSellerRefs: (state) => {
    let customerRefs = [].concat(state.filteredByCustomerRef)
    let allUnits = state.dropUnitsHash
    Object.keys(allUnits).forEach((key) => {
      if (allUnits[key].transport != null) {
        if (allUnits[key].transport.order != null) {
          if (allUnits[key].transport.order.seller.ref != null) {
            if (customerRefs.indexOf(allUnits[key].transport.order.seller.ref) < 0) {
              customerRefs.push(allUnits[key].transport.order.seller.ref)
            }
          }
        }
      }
    })
    return customerRefs
  },
  getDropItemsCategory: (state) => {
    let categories = []
    let allUnits = state.dropUnitsHash
    Object.keys(allUnits).forEach((key) => {
      if (allUnits[key] != null) {
        if (allUnits[key].items != null) {
          allUnits[key].items.forEach(({ category }) => {
            if (category != null && category !== '') {
              if (categories.indexOf(category) < 0) {
                categories.push(category)
              }
            }
          })
        }
      }
    })
    return categories
  },
  getExportLoading: (state) => {
   return state.isExportLoading
  },
  getDropAvailablePallets: (state) => {
    const availablePalletsGroups = {
      'CustomPallet': state.availablePallets.filter(({ type }) => {
        return type.indexOf('CustomPallet') >= 0
      }),
      'EurPallet': state.availablePallets.filter(({ type }) => (type === 'EurPallet'))
    }
    return availablePalletsGroups
  }
}
export default getters
